import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpModule } from '@angular/http';
import { MyApp } from './app.component';

import { ProgramaProvider } from '../providers/programa/programa';

import { CongresosProvider } from '../providers/congresos/congresos';
import { PonentesProvider } from '../providers/ponentes/ponentes';

import { GlobalProvider } from '../providers/global/global';

import { PaginasProvider } from '../providers/paginas/paginas';
import { PreguntasProvider } from '../providers/preguntas/preguntas';
import { DocumentosProvider } from '../providers/documentos/documentos';
/*import { HomePage } from '../pages/home/home';
import { PaginaprincipalPage } from "../pages/paginaprincipal/paginaprincipal";
import { CongresoPage } from '../pages/congreso/congreso';
import { ProgramaPage } from '../pages/programa/programa';
import { PonentesPage } from '../pages/ponentes/ponentes';
import { DocumentosPage } from '../pages/documentos/documentos';
import { LinksPage } from '../pages/links/links';
import { EncuestaPage } from '../pages/encuesta/encuesta';
import { DetalleprogramaPage } from '../pages/detalleprograma/detalleprograma';
import { RutasDirective } from '../directives/rutas/rutas';
import { ProgramaEditPage } from '../pages/programa-edit/programa-edit';
import { PonentesEditPage } from '../pages/ponentes-edit/ponentes-edit';
import { PreguntasPage } from '../pages/preguntas/preguntas';
import { CongresoEditPage } from '../pages/congreso-edit/congreso-edit';

import { PreguntadetallePage } from '../pages/preguntadetalle/preguntadetalle';
import { PreguntadetallerespuestasPage } from '../pages/preguntadetallerespuestas/preguntadetallerespuestas';
import { PreguntaseditPage } from '../pages/preguntasedit/preguntasedit';
import { PreguntasdetalleEditPage } from '../pages/preguntasdetalle-edit/preguntasdetalle-edit';
import { PonentesdetallePage } from '../pages/ponentesdetalle/ponentesdetalle';

import { DocumentosEditPage } from '../pages/documentos-edit/documentos-edit';
import { PdfviewerPage } from '../pages/pdfviewer/pdfviewer';
import { LinksEditPage } from '../pages/links-edit/links-edit';
import { PatrocinadoresPage } from '../pages/patrocinadores/patrocinadores';
import { PatrocinadorEditPage } from '../pages/patrocinador-edit/patrocinador-edit';
import { PatrocinadordetallePage } from '../pages/patrocinadordetalle/patrocinadordetalle';
import { PonentesSelectPage } from '../pages/ponentes-select/ponentes-select';
import { NotificacionesPage } from '../pages/notificaciones/notificaciones';
import { NotificacionesEditPage } from '../pages/notificaciones-edit/notificaciones-edit';
import { LoginPage } from '../pages/login/login';
import { RecuerdaPage } from '../pages/recuerda/recuerda';
import { RegistroPage } from '../pages/registro/registro';
import { PanelPage } from '../pages/panel/panel';
import { PresentacionEditPage } from '../pages/presentacion-edit/presentacion-edit';
import { BuscacongresoPage } from '../pages/buscacongreso/buscacongreso';
import { CongresoNuevoPage } from '../pages/congreso-nuevo/congreso-nuevo';
import { MapaPage } from '../pages/mapa/mapa';
import { EncuestaEditPage } from '../pages/encuesta-edit/encuesta-edit';*/
import { EditortextoPage } from '../pages/editortexto/editortexto';
import { File } from '@ionic-native/file';
import { Base64 } from '@ionic-native/base64';
import { FileTransfer } from '@ionic-native/file-transfer';
import { DocumentViewer } from '@ionic-native/document-viewer';

import { LinksProvider } from '../providers/links/links';

import { PatrocinadoresProvider } from '../providers/patrocinadores/patrocinadores';

import { NotificacionesProvider } from '../providers/notificaciones/notificaciones';

import { LoginProvider } from '../providers/login/login';
import { SQLite } from '@ionic-native/sqlite';

import { CKEditorModule } from 'ngx-ckeditor';
import {Camera} from '@ionic-native/camera';
import { ImagenesProvider } from '../providers/imagenes/imagenes';

import { Geolocation } from '@ionic-native/geolocation';
import { GoogleMaps } from '../providers/google-maps/google-maps';

import { MapaPageModule } from '../pages/mapa/mapa.module';
import { EncuestasProvider } from '../providers/encuestas/encuestas';

import { EtiquetasProvider } from '../providers/etiquetas/etiquetas';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { Network } from '@ionic-native/network';
import { InternetProvider } from '../providers/internet/internet';

import {Keyboard} from "@ionic-native/keyboard";
import { MenuProvider } from '../providers/menu/menu';
import { AlertController } from 'ionic-angular';
import { Push, PushObject, PushOptions } from '@ionic-native/push'
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { LogProvider } from '../providers/log/log';
import { IndicadoresProvider } from '../providers/indicadores/indicadores';
import { ChartsModule } from 'ng2-charts-x';
import { LicenciasProvider } from '../providers/licencias/licencias';
import { HomePage } from '../pages/home/home';
import { AsistentesProvider } from '../providers/asistentes/asistentes';
import { ReunionProvider } from '../providers/reunion/reunion';
import { ChatProvider } from '../providers/chat/chat';
//import {RoundProgressModule} from 'angular-svg-round-progressbar';
import {RoundProgressModule} from 'angular-svg-round-progressbar';
import { SalaProvider } from '../providers/sala/sala';
import { ComentariosProvider } from '../providers/comentarios/comentarios';
import { SocialSharing } from "@ionic-native/social-sharing";
/*import { ProgramaPageModule } from '../pages/programa/programa.module';
import { PaginaprincipalPageModule } from '../pages/paginaprincipal/paginaprincipal.module';
import { HomePageModule } from '../pages/home/home.module';*/
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({
  declarations: [
    MyApp,
  //  HomePage,
    //PaginaprincipalPage,
   /* CongresoPage,
    ProgramaPage,
    PonentesPage,
    DocumentosPage,
    LinksPage,
    EncuestaPage,
    DetalleprogramaPage,
    ProgramaEditPage,
    PonentesEditPage,
    CongresoEditPage,
    PreguntasPage,
    PreguntadetallePage,
    PreguntadetallerespuestasPage,
    PreguntaseditPage,
    PreguntasdetalleEditPage,
    PonentesdetallePage,
    DocumentosEditPage,
    PdfviewerPage,
    LinksEditPage,
    PatrocinadoresPage,
    PatrocinadorEditPage,
    PatrocinadordetallePage,
    PonentesSelectPage,
    NotificacionesPage,
    NotificacionesEditPage,
    LoginPage,
    RecuerdaPage,
    RegistroPage,
    PanelPage,
    PresentacionEditPage,
    BuscacongresoPage,CongresoNuevoPage,EncuestaEditPage,*/
    EditortextoPage,

  ],
  imports: [
    BrowserModule,
    HttpModule,
    RoundProgressModule,
    IonicModule.forRoot(MyApp, {mode: 'md',
      backButtonText: ''}),
      ChartsModule,
    CKEditorModule,  
   // RoundProgressModule,
    //HomePageModule,
   // MapaPageModule, 
   // PaginaprincipalPageModule,
    //ProgramaPageModule,      
    HttpClientModule,
    TranslateModule.forRoot({
          loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
          }
      })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
 //   HomePage,
   // PaginaprincipalPage,
  /*  CongresoPage,
    ProgramaPage,
    PonentesPage,
    DocumentosPage,
    LinksPage,
    EncuestaPage,
    DetalleprogramaPage,
    ProgramaEditPage,
    PonentesEditPage,
    CongresoEditPage,
    PreguntasPage,
    PreguntadetallePage,
    PreguntadetallerespuestasPage,
    PreguntaseditPage,
    PreguntasdetalleEditPage,
    PonentesdetallePage,
    DocumentosEditPage,
    PdfviewerPage,
    LinksEditPage,
    PatrocinadoresPage,
    PatrocinadorEditPage,
    PatrocinadordetallePage,
    PonentesSelectPage,
    NotificacionesPage,
    NotificacionesEditPage,
    LoginPage,
    RecuerdaPage,
    RegistroPage,
    PanelPage,
    PresentacionEditPage,
    BuscacongresoPage,
    CongresoNuevoPage,
    MapaPage,EncuestaEditPage,*/
    EditortextoPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Geolocation,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    GoogleMaps,
    ProgramaProvider,
    CongresosProvider,
    PonentesProvider,
    GlobalProvider,
    PaginasProvider,
    PreguntasProvider,
    DocumentosProvider,
    File,
    DocumentViewer,
    FileTransfer,
    LinksProvider,
    PatrocinadoresProvider,
    NotificacionesProvider,
    Base64,
    LoginProvider,
    SQLite,
    Camera,
    ImagenesProvider,
    EncuestasProvider,
    EtiquetasProvider,
    Network,
    InternetProvider,
   Keyboard,
    MenuProvider,
    AlertController,
    Push,
    InAppBrowser,
    LogProvider,
    IndicadoresProvider,
    LicenciasProvider,
    AsistentesProvider,
    ReunionProvider,
    ChatProvider,
    SalaProvider,
    ComentariosProvider,
    SocialSharing,
    
  ]
})
export class AppModule {}
// IonicModule.forRoot(MyApp, { mode: 'md' }),


// WEBPACK FOOTER //
// ./src/app/app.module.ts